<template>
  <div>
    <MobileNavigation></MobileNavigation>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 bg-slate-900 p-2" style="height:100%">
        <br>       
        <form class="form-style text-center pt-2">
            <input class="mt-2 border rounded-lg border-gray-300 w-full mt-5" id="addExpenseInput" type="text" placeholder="Add expense" maxlength="100" required> <br>
            <input class="mt-2 border rounded-lg border-gray-300 w-full" id="expenceDateInput" type="date" placeholder="Expense date" maxlength="100" required> <br>
            <input class="mt-2 border rounded-lg border-gray-300 w-full" id="expenseAmountInput" type="text" placeholder="Expense amount" maxlength="50" required> <br>
            <input class="mt-2 border rounded-lg border-gray-300 w-full" id="paymentModeInput" type="text" placeholder="Payment mode" maxlength="50" required>
            <br>
            <div id="cameraImages" class="text-left mt-2">
              <br>
              <span id="cameraContainer">
                <span class="bg-black pl-2 pr-2 pt-4 pb-2">
                  <i class="fas fa-camera text-white text-4xl"></i>
                </span>

              </span>
              
                <span id="plusContainer" class="bg-black ml-1 pl-2 pr-2 pt-4 pb-2" v-on:click="addMoreImage">
                  <i class="fas fa-plus text-white text-4xl"></i>
                </span>
              
            </div>
            <button type="submit" class="mt-4 p-2 w-full text-white bg-black rounded-lg">Submit</button>
        </form>

      </div>
  </div>
</template>
<style scoped>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }


    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
      text-decoration: none;
    }

    </style>

<script>
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'


export default {
  props: ["sessions"],

  components: {
    MobileNavigation,
    Welcome,
    PageTitle,
    JetNavLink,

  },
  data() {
    return {
      title: "Attendance Menu",
      username: null,
      password: null,

    };
  },
  methods: {

    addMoreImage() {
      var camera='<span class=\"bg-black pl-2 pr-2 pt-4 pb-2\"><i class=\"fas fa-camera text-white text-4xl\"></i></span>';
      var element=document.getElementById("cameraContainer");
      element.appendChild(camera);
    },

    openPunchMap(){
            app.startPunchMap();
        }
  },
  mounted() {
    
  },
};
</script>
